import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
	selector: "ic-katz-wizard-card",
	templateUrl: "./katz-wizard.component.html",
	styleUrls: ["./katz-wizard.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class KATZWizardComponent {
	readonly matDialogRef = inject<MatDialogRef<KATZWizardComponent>>(MatDialogRef);
	private readonly data = inject<{
		katz: string;
		isDemented: boolean;
	}>(MAT_DIALOG_DATA);

	katz: string;
	isDemented: boolean;

	constructor() {
		this.katz = this.data.katz;
		this.isDemented = this.data.isDemented;
	}

	emit(event: string) {
		this.matDialogRef.close(event);
	}
}
